export const UserRoles = {
  manager: {
    key: 'manager',
    value: 'manager',
  },
  contentManager: {
    key: 'contentManager',
    value: 'Content Manager',
  },
  admin: {
    key: 'admin',
    value: 'Admin',
  },
};



// WEBPACK FOOTER //
// ./src/services/userRole/config.ts